import React from "react";
import Card from "components/card";
import { Heart, ThumbsUp } from "lucide-react";
import Button from "components/button";
import { recognitionFilters } from "variables/constants";
import { connect } from "react-redux";
import {
    doUserReactionCreate,
     doUserReactionDelete
} from "../../../../../redux/userreaction/userReactionState";

export const URCTYPE_HEART = 116;
export const URCTYPE_REACT = 117;

const RecognitionCard = ({
    recordData,
    rcw_id,
    doCreate,
    deDelete,
    authUser
}) => {
    const filterStyle = recognitionFilters.find(
        f => f.value === recordData?.recognition_type?.toLowerCase()
    );

    const senderDisplayName =
        recordData?.created_by?.id === authUser?.id
            ? "You" : recordData?.sender_name?.trim();

    const recipientDisplayName =
        recordData?.rcw_receiver_user_id === authUser?.id
            ? "You" : recordData?.recipient_name?.trim();

    
    const userHeartReactions = recordData?.user_reacted?.filter(
        r => r.type === URCTYPE_HEART
    ) ?? [];
    
    const heartCount = recordData?.user_reaction_counts?.Heart ?? 0;
    
    const handleHeartClick = () => {
        if (!authUser?.id) return;

        if (userHeartReactions.length > 0) {
            const reactionToDelete = userHeartReactions[userHeartReactions.length - 1];
            deDelete({ 
                recordId: reactionToDelete.id,  
                mode: 'reload' 
            });
        } else {
            doCreate({
                urc_user_id: authUser.id,
                urc_type_id: URCTYPE_HEART,
                urc_recognition_wall_id: rcw_id,
            });
        }

    };

    const hasUserReacted = userHeartReactions.length > 0;

    return (
        <Card
            className={`text-slate-900 flex flex-col gap-6 rounded-2xl border-2
            ${filterStyle?.border} ${filterStyle?.bgColor} hover:shadow-lg transition-all duration-300 group`}
        >
            <div className="pb-6 p-5">
                <div className="flex items-start gap-4">
                    <div className="relative">
                        <span
                            className={`
                                relative flex items-center justify-center border-2 border-white
                                rounded-full w-12 h-12 text-white font-semibold shadow-md
                                bg-gradient-to-br ${filterStyle?.bg} transition-transform duration-300
                            `}
                        >
                            {recordData?.sender_initial}
                        </span>
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2 mb-2"> 
                            <div>
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="font-semibold text-sm dark:text-zinc-100">
                                        {senderDisplayName}
                                    </span>
                                    {recipientDisplayName && 
                                        <>
                                            <span className="text-slate-700 text-xs">&#8594;</span>
                                            <span className="font-semibold text-sm text-purple-600 dark:text-purple-400">
                                                {recipientDisplayName}
                                            </span>
                                        </>
                                    }
                                </div>
                                <div className="flex items-center gap-2 mt-1">
                                    <span
                                        className={`inline-flex items-center justify-center rounded-lg font-medium
                                            w-fit whitespace-nowrap shrink-0 text-xs px-2 py-0 border
                                            ${filterStyle?.bgColor} ${filterStyle?.border}
                                        `}
                                    >
                                        <span className="mr-1">{filterStyle?.icon}</span> 
                                        {filterStyle?.label}
                                    </span>
                                    <span className="text-xs text-slate-700">
                                        {recordData?.created_at_ago}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <p className="text-sm text-slate-700 dark:text-zinc-300 mb-3 leading-relaxed">
                            {recordData?.rcw_message}
                        </p>
                        <div className="flex items-center gap-4">
                            <Button
                                onClick={handleHeartClick}
                                className={`flex items-center gap-1.5 text-xs font-medium
                                    hover:shadow-none transition-transform duration-300 hover:scale-110 !p-0
                                    ${hasUserReacted
                                        ? "text-pink-600 dark:text-pink-400"
                                        : "text-slate-700 hover:text-pink-600 dark:hover:text-pink-400"
                                    }
                                `}
                            >
                                <Heart
                                    className="w-4 h-4 transition-all"
                                    fill={hasUserReacted ? "currentColor" : "none"}
                                />
                                <span>{heartCount}</span>
                            </Button>
                            <Button
                                className="flex items-center gap-1.5 text-xs text-slate-700 hover:text-emerald-600 dark:hover:text-emerald-400 transition-colors hover:shadow-none !p-0"
                            >
                                <ThumbsUp className="w-4 h-4"/>
                                <span>React</span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
};

const mapStateToProps = (state) => ({
    authUser: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
    doCreate: (data) => dispatch(doUserReactionCreate(data)),
    deDelete: (data) => dispatch(doUserReactionDelete(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(RecognitionCard);